import { Component } from '@angular/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { ProductBannerComponent } from 'app/components/product-banner/product-banner.component';
import { ProductContentComponent } from 'app/components/product-content/product-content.component';
import { ProductBenefitsComponent } from 'app/components/product-benefits/product-benefits.component';
import { ProductListsComponent } from 'app/components/product-lists/product-lists.component';
import { ProductStepsComponent } from 'app/components/product-steps/product-steps.component';
import { ProductDetailModalComponent } from 'app/components/product-detail-modal/product-detail-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApplicationService } from 'app/services/application.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalComponent } from 'app/components/modal/modal.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-new-products',
    standalone: true,
    templateUrl: './new-products.component.html',
    styleUrl: './new-products.component.scss',
    imports: [
        HeaderComponent,
        FooterComponent,
        ProductBannerComponent,
        ProductContentComponent,
        ProductBenefitsComponent,
        ProductListsComponent,
        ProductStepsComponent,
        ProductDetailModalComponent,
        TranslateModule,
    ],
})
export class NewProductsComponent {
    bankList = [];
    dialogClosed: boolean = true;
    initialBankList = [];
    bankProductsList = [];
    digitalBankProductsList = [];
    p2pProductsList: any = [];
    groupedBanks: { [key: string]: any[] } = {};
    selectedBank: string | null = null;
    selectedBankProducts: any[] = [];
    clickedOutside: boolean = false;
    isAuthenticated: boolean = false;
    selectedLanguage: any;
    caseId: any;
    disableSelectedProductBtn: boolean = false;
    disableMatchingProductsBtn: boolean = false;
    getUtmId: any;
    getUtmSource: any;
    isFromCalculator: boolean = false;
    campignSource: string = '';
    campaignPartner: string = '';

    constructor(
        public dialog: MatDialog,
        private applicationService: ApplicationService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService
    ) {
        this.selectedLanguage = localStorage.getItem('language');
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
        this.isFromCalculator =
            this.router.getCurrentNavigation().extras.state?.calculator;
    }

    ngOnInit() {
        this.getUtmId = JSON.parse(sessionStorage.getItem('utm_id'));
        this.getUtmSource = JSON.parse(sessionStorage.getItem('utm_source'));
        this.getProductList();

        // assigning returnUrl flag for redirection
        this.activatedRoute.queryParams.subscribe((params) => {
            const { productCode, source, campaignPartner } = params;
            const { matchingProduct } = params;
            if (source) this.campignSource = source;
            if (campaignPartner) this.campaignPartner = campaignPartner;
            if (
                matchingProduct ||
                (params.utm_source && params.utm_id == 'BRP') ||
                this.isFromCalculator
            ) {
                this.checkMatchingProducts();
            } else if (productCode) {
                this.onSelectProduct(productCode, null);
            }
        });
    }

    getProductList() {
        this.applicationService.getApplicationProductList().subscribe({
            next: (res) => {
                this.bankList = res;
                const array = this.bankList;
                this.initialBankList = this.nestedCopy(array);

                // this.bankList.sort((a, b) => {
                //     const bmComparison = a.fiPartnerDescBm.localeCompare(
                //         b.fiPartnerDescBm
                //     );
                //     if (this.selectedLanguage == 'bm') {
                //         return bmComparison;
                //     }
                //     return a.fiPartnerDescEng.localeCompare(b.fiPartnerDescEng);
                // });
                // this.bankList = this.bankList.map((bank) => {
                //     bank.products.sort((a, b) =>
                //         a.productName
                //             .toLowerCase()
                //             .localeCompare(b.productName.toLowerCase())
                //     );
                //     return bank;
                // });

                this.p2pProductsList = this.bankList
                    .map((partner) => ({
                        ...partner,
                        products: partner.products.filter((p) => {
                            const isPGProduct =
                                p.prodTag?.includes('PG') &&
                                !p.prodTag.includes('BRP');

                            if (p.productCategory === 'P2P' && !isPGProduct)
                                return p;
                        }),
                    }))
                    .filter((partner) => partner.products.length > 0);

                this.bankProductsList = this.bankList
                    .map((partner) => ({
                        ...partner,
                        products: partner.products.filter((p) => {
                            const isPGProduct =
                                p.prodTag?.includes('PG') &&
                                !p.prodTag.includes('BRP');

                            if (
                                p.productCategory === 'BANK' ||
                                p.productCategory === 'CGC'
                            ) {
                                if (!isPGProduct) {
                                    return p;
                                }
                            }
                        }),
                    }))
                    .filter((partner) => partner.products.length > 0);
                // filtering Digital bank product List
                this.digitalBankProductsList = this.bankList
                    .map((partner) => ({
                        ...partner,
                        products: partner.products.filter((p) => {
                            const isPGProduct =
                                p.prodTag?.includes('PG') &&
                                !p.prodTag.includes('BRP');

                            if (
                                p.productCategory === 'DIGITAL BANK'
                            ) {
                                if (!isPGProduct) {
                                    return p;
                                }
                            }
                        }),
                    }))
                    .filter((partner) => partner.products.length > 0);
            },
            error: (err) => {
                this.toastr.error(err.error.message);
            },
        });
    }

    nestedCopy(array) {
        return Array.from(array);
    }

    onClickEligibility() {
        this.checkMatchingProducts();
    }

    onSelectProduct(productCode?, draftStatus?) {
        this.disableSelectedProductBtn = true;
        let productData: any = {
            selection: [
                {
                    prodCode: productCode,
                },
            ],
        };

        if (draftStatus == 'startNewApp') {
            productData['deleteAndContinue'] = true;
        }

        if (this.getUtmSource && this.getUtmId == 'BRP') {
            productData['source'] = this.getUtmSource;
        } else if (this.getUtmId == 'CIDB') {
            productData['source'] = this.getUtmId;
        } else if (this.campignSource) {
            productData['source'] = this.campignSource?.toUpperCase();
        }

        if (this.campaignPartner) {
            productData['campaignPartner'] = this.campaignPartner;
        }

        if (this.isAuthenticated) {
            this.applicationService.setProductData(productData).subscribe({
                next: (res: any) => {
                    let response = res;
                    if (response.drafts) {
                        let draftData = response.drafts;
                        if (
                            draftData.length > 0 &&
                            draftStatus !== 'startNewApp'
                        ) {
                            let selectedProductCode = draftData[0]
                                .selectedProducts
                                ? draftData[0].selectedProducts
                                : productCode;

                            let selectedProductName = draftData[0].productName;

                            this.confirmDraftDialog(
                                draftData,
                                selectedProductCode,
                                'selectProduct',
                                selectedProductName,
                                productCode
                            );
                        } else if (
                            draftData.length > 0 &&
                            draftStatus == 'startNewApp'
                        ) {
                            draftData.forEach((element) => {
                                this.caseId = element.caseId;
                            });
                            this.router.navigate(['/corporate'], {
                                state: {
                                    setProductDetails: this.caseId,
                                    fromResume: true,
                                    prodCode: productCode,
                                },
                            });
                        }
                    } else {
                        response.forEach((element) => {
                            this.caseId = element.caseId;
                        });
                        let selectedProductName =
                            response[0].prodSelectionList[0].productName;

                        this.router.navigate(['/corporate'], {
                            state: {
                                setProductDetails: this.caseId,
                                prodCode: productCode,
                                productName: selectedProductName,
                            },
                        });
                    }
                },
                error: (err) => {
                    this.disableSelectedProductBtn = false;
                    if (err.error.code == 400) {
                        if (this.selectedLanguage == 'bm') {
                            this.toastr.error('URL atau Kod Produk Tidak Sah.');
                        } else {
                            this.toastr.error('Invalid URL or Product Code.');
                        }
                    } else {
                        this.toastr.error(err.error.message);
                    }
                },
            });
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: `/business-financing?productCode=${productCode}`,
                },
            });
        }
    }

    confirmDraftDialog(
        draftData,
        selectedProductCode?,
        appProductFlow?,
        selectedProductName?,
        prodCode?
    ) {
        //single draft journey
        let noOfDrafts = draftData.length;
        const dialogRef = this.dialog.open(ModalComponent, {
            data: {
                noOfDrafts,
            },
            scrollStrategy: new NoopScrollStrategy(),
        });

        dialogRef.afterClosed().subscribe((result) => {
            this.disableSelectedProductBtn = false;
            this.disableMatchingProductsBtn = false;
            if (result.data == 'resumeDraft') {
                draftData.forEach((element) => {
                    this.caseId = element.caseId;
                });
                let qType;
                draftData.map((ele) => {
                    qType = ele.qType;
                });
                this.resumeApp(
                    this.caseId,
                    qType,
                    selectedProductCode,
                    selectedProductName
                );
            } else if (result.data == 'startNewApp') {
                //Here the appProductFlow is coming from clicking type of product
                if (appProductFlow == 'checkMatchingProducts') {
                    this.checkMatchingProducts('startNewApp');
                } else if (appProductFlow == 'selectProduct') {
                    this.onSelectProduct(prodCode, 'startNewApp');
                }
            }
        });
    }

    checkMatchingProducts(draftStatus?) {
        this.disableMatchingProductsBtn = true;

        let productData = {};
        if (draftStatus == 'startNewApp') {
            productData['deleteAndContinue'] = true;
        }

        if (this.getUtmSource && this.getUtmId == 'BRP') {
            productData['source'] = this.getUtmSource;
        } else if (this.getUtmId == 'CIDB') {
            productData['source'] = this.getUtmId;
        }

        if (this.isAuthenticated) {
            this.applicationService.createCaseProduct(productData).subscribe({
                next: (res: any) => {
                    let response = res;
                    if (response.drafts) {
                        let draftData = response.drafts;
                        if (
                            draftData.length > 0 &&
                            draftStatus !== 'startNewApp'
                        ) {
                            let selectedProductCode =
                                draftData[0].selectedProducts;
                            let selectedProductName = draftData[0].productName;
                            this.confirmDraftDialog(
                                draftData,
                                selectedProductCode,
                                'checkMatchingProducts',
                                selectedProductName
                            );
                        } else if (
                            draftData.length > 0 &&
                            draftStatus == 'startNewApp'
                        ) {
                            draftData.forEach((element) => {
                                this.caseId = element.caseId;
                            });
                            this.router.navigate(['/corporate'], {
                                state: {
                                    setProductDetails: this.caseId,
                                    checkMatchingProduct: true,
                                },
                            });
                        }
                    } else {
                        response.forEach((element) => {
                            this.caseId = element.caseId;
                        });
                        this.router.navigate(['/corporate'], {
                            state: {
                                setProductDetails: this.caseId,
                                checkMatchingProduct: true,
                            },
                        });
                    }
                },
                error: (err) => {
                    this.disableMatchingProductsBtn = false;
                    this.toastr.error(err.error.message);
                },
            });
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: `/business-financing?matchingProduct=true`,
                },
            });
        }
    }

    resumeApp(
        caseId: string,
        qType: string,
        selectedProduct?: string,
        selectedProductName?: string
    ) {
        const matchedProductsFlowArr = [
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGC_USR_INFO',
            'LOAN_CGC_UPD_USR_INFO',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGC_BSNS_INFO',
            'LOAN_CGC_FI_OFFR_SCR',
            'LOAN_CGC_UPLD_DOC',
        ];
        const selectProductFlowArr = [
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGCP_UPD_USR_INFO',
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGCP_BSNS_INFO',
            'LOAN_CGCP_chk_elig',
            'LOAN_CGCP_UPLD_DOC',
        ];
        let appProductFlow; //coming from api if app is resumed
        let isMatchedProductsFlow;
        if (matchedProductsFlowArr.includes(qType)) {
            appProductFlow = 'checkMatchingProducts';
            isMatchedProductsFlow = true;
        } else if (selectProductFlowArr.includes(qType)) {
            appProductFlow = 'selectProduct';
            isMatchedProductsFlow = false;
        }

        const navigationExtras = {
            state: {
                fromResume: true,
            },
        };
        if (appProductFlow == 'checkMatchingProducts') {
            navigationExtras.state['checkMatchingProduct'] = true;
        }

        if (this.getAppStepNo(qType) == 1) {
            navigationExtras.state['setProductDetails'] = caseId;
            navigationExtras.state['productName'] = selectedProductName;
            this.router.navigate(['/corporate'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 2) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 3) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 4) {
            //check-eligibility or matched products flow
            let productFlowData = {
                caseId: caseId,
                prodCode: selectedProduct,
                productFlow: isMatchedProductsFlow,
            };
            navigationExtras.state['productFlowData'] = productFlowData;
            this.router.navigate(['/business-info'], navigationExtras);
        } else {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/corporate'], navigationExtras);
        }
    }

    getAppStepNo(qType: string) {
        let step1Arr = [
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGC_USR_INFO',
        ];
        let step2Arr = ['LOAN_CGCP_UPD_USR_INFO', 'LOAN_CGC_UPD_USR_INFO'];
        let step3Arr = ['LOAN_CGCP_BSNS_INFO', 'LOAN_CGC_BSNS_INFO'];
        let step4Arr = ['LOAN_CGCP_chk_elig', 'LOAN_CGC_FI_OFFR_SCR'];
        let step5Arr = ['LOAN_CGCP_UPLD_DOC', 'LOAN_CGC_UPLD_DOC'];
        if (step1Arr.includes(qType)) {
            return 1;
        } else if (step2Arr.includes(qType)) {
            return 2;
        } else if (step3Arr.includes(qType)) {
            return 3;
        } else if (step4Arr.includes(qType)) {
            return 4;
        } else if (step5Arr.includes(qType)) {
            return 4;
        }
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    /* HEADER AREA */
    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    openProducts(bankDetails): void {
        let data = bankDetails;
        data.selectedLanguage = this.selectedLanguage;
        data.showBanks = true;
        const dialogRef = this.dialog.open(ProductDetailModalComponent, {
            width: '90%',
            maxWidth: '800px',
            panelClass: 'products-modal-container',
            disableClose: false,
            data,
        });

        dialogRef.afterOpened().subscribe(() => {
            this.dialogClosed = false;
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result?.isCheckMatchingProducts) {
                    this.checkMatchingProducts();
                } else if (result?.isCalculatorClick) {
                    this.router.navigate(['/financing-calculator']).then(() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    });
                }
            }
            this.dialogClosed = true;
        });
    }
}
